import { render, staticRenderFns } from "./TimeUp.vue?vue&type=template&id=789e08f7&"
import script from "./TimeUp.vue?vue&type=script&lang=js&"
export * from "./TimeUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports